import { fetchBrands } from './get-pos-brands';

export const BrandsAPI = {
  fetchBrands,
};
